import {Box, IconButton, Popover, Stack, Tooltip, Typography} from "@mui/material";
import {Check, Close, ContentCopy, Delete, Edit, Link, LocationOn, PlaylistAdd} from "@mui/icons-material";

const locale = localStorage.getItem('tm-locale') || 'en-gb';

export default function ItemPopover(props) {
    const {
        anchor,
        onClose,
        type,
        item,
        beginDate,
        beginEdit,
        openCreateMenu,
        endDate,
        markComplete,
        submitDelete,
        alterItem,
        mobile,
    } = props;
    
    return (
        <Popover
            open={Boolean(anchor)}
            anchorEl={anchor}
            onClose={onClose}
            sx={{
                '.MuiPaper-root': {
                    borderRadius: '7px',
                    border: 'solid 1px #555',
                }
            }}
        >
            {item &&
                <Box
                    sx={{
                        position: 'relative',
                        borderRadius: 0,
                        p: '10px',
                        minWidth: {
                            xs: 'calc(100% - 30px)',
                            sm: '300px',
                        },
                        background: '#222',
                        color: 'white',
                        paddingRight: mobile ? '10px' : `${
                            150 +
                            (type === 'Task' ? 50 : 0) +
                            (type !== 'Period' ? 50 : 0) +
                            (item.link ? 50 : 0)
                        }px`,
                    }}
                >
                    <Box
                        sx={{
                            position: {
                                xs: 'block',
                                sm: 'absolute',
                            },
                            top: '5px',
                            right: '5px',
                        }}
                    >
                        {type === 'Task' &&
                            <Tooltip title={item.complete ? "Mark incomplete" : "Mark complete"}>
                                <IconButton
                                    sx={{
                                        color: '#cccccc',
                                    }}
                                    onClick={() => {
                                        markComplete(item.key, !item.complete);
                                        onClose();
                                    }}
                                >
                                    {
                                        item.complete === 1 ?
                                            <Close /> :
                                            <Check />
                                    }
                                </IconButton>
                            </Tooltip>
                        }
                        {item.link &&
                            <Tooltip title="Go to assignment">
                                <IconButton
                                    sx={{
                                        color: '#cccccc',
                                    }}
                                    onClick={() => {
                                        if (item.link.startsWith('CANVAS:')) {
                                            const lastDelimiterIndex = item.link.lastIndexOf(':');
                                            const courseId = item.link.substring(7, lastDelimiterIndex);
                                            const assignmentId = item.link.substring(lastDelimiterIndex + 1);

                                            window.open(
                                                `https://gatech.instructure.com/courses/${courseId}/assignments/${assignmentId}/`,
                                                '_blank',
                                                'noopener,noreferrer'
                                            );
                                        }

                                        onClose();
                                    }}
                                >
                                    <Link />
                                </IconButton>
                            </Tooltip>
                        }
                        {type !== 'Period' &&
                            <Tooltip title="Create period">
                                <IconButton
                                    sx={{
                                        color: '#cccccc',
                                    }}
                                    onClick={() => {
                                        if (type === 'Event') {
                                            alterItem('Period', {
                                                name: item.name,
                                                start: item.start.getTime() < beginDate.getTime() ? beginDate : item.start,
                                                end: item.end.getTime() > endDate.getTime() ? endDate : item.end,
                                                description: item.description,
                                                location: item.location,
                                                labels: item.labels,
                                            });
                                        } else {
                                            openCreateMenu('Period', {
                                                name: item.name,
                                                start: item.start.getTime() < beginDate.getTime() ? beginDate : item.start,
                                                end: item.end.getTime() > endDate.getTime() ? endDate : item.end,
                                                description: item.description,
                                                location: item.location,
                                                labels: item.labels,
                                            })();
                                        }

                                        onClose();
                                    }}
                                >
                                    <PlaylistAdd />
                                </IconButton>
                            </Tooltip>
                        }
                        <Tooltip title="Duplicate">
                            <IconButton
                                sx={{
                                    color: '#cccccc',
                                }}
                                onClick={() => {
                                    openCreateMenu(type, {
                                        name: item.name,
                                        start: item.start.getTime() < beginDate.getTime() ? beginDate : item.start,
                                        end: item.end.getTime() > endDate.getTime() ? endDate : item.end,
                                        description: item.description,
                                        location: item.location,
                                        labels: item.labels,
                                    })();
                                    onClose();
                                }}
                            >
                                <ContentCopy />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit">
                            <IconButton
                                sx={{
                                    color: '#cccccc',
                                }}
                                onClick={() => {
                                    onClose();
                                    beginEdit(type, item.key)();
                                }}
                            >
                                <Edit />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <IconButton
                                sx={{
                                    color: '#cccccc',
                                }}
                                onClick={() => {
                                    onClose();
                                    submitDelete(type, item.key)();
                                }}
                            >
                                <Delete />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Typography
                        m="0 0 7px 3px"
                        fontSize="14pt"
                        fontWeight="700"
                        color="#d5d5d5"
                    >
                        {item.name}
                    </Typography>
                    <Typography
                        m="0 0 10px 3px"
                        fontSize="11pt"
                        fontWeight="500"
                        color="#c5c5c5"
                    >
                        {item.start.toLocaleString(locale, { month: 'short', weekday: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' })} -&nbsp;
                        {item.end.toLocaleString(locale, { month: 'short', weekday: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' })}
                    </Typography>
                    {item.location &&
                        <Stack
                            direction="row"
                            alignItems="center"
                            sx={{
                                mb: '10px',
                            }}
                        >
                            <LocationOn />
                            <Typography
                                m="5px 7px 0 7px"
                                color="#c5c5c5"
                                fontSize="10pt"
                                fontWeight="700"
                            >
                                {item.location}
                            </Typography>
                        </Stack>
                    }
                    {item.description &&
                        <textarea
                            style={{
                                margin: "5px 7px 0 3px",
                                color: "#c5c5c5",
                                fontSize: "11pt",
                                fontWeight: "400",
                                width: mobile ? "100%" : "400px",
                                minWidth: mobile && "100%",
                                maxWidth: '100%',
                                textOverflow: "ellipsis",
                                background: 'none',
                                border: 'none',
                                overflowY: 'hidden',
                                outline: 'none',
                                fontFamily: 'inherit',
                                fieldSizing: 'content',
                                maxHeight: '10lh',
                            }}
                            readOnly={true}
                            value={item.description}
                        />
                    }
                </Box>
            }
        </Popover>
    );
}